import { hasAnyFiltersApplied } from "../../../scenes/stack/environment/filters/utils";
import CustomToolTip from "../../CustomTooltip";
import TextButton from "../../buttons/TextButton";

const SaveFiltersButton = ({ appliedFilters, onSaveClick = () => {} }) => {
  const canSaveFilters = () => {
    return hasAnyFiltersApplied(appliedFilters);
  };

  return (
    <>
      {canSaveFilters() && (
        <CustomToolTip title="Save the current applied filters as a new filter set">
          <span>
            <TextButton onClick={onSaveClick} color="inherit" size="small">
              Save Filters
            </TextButton>
          </span>
        </CustomToolTip>
      )}
    </>
  );
};

export default SaveFiltersButton;
